import { Box, Button, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, useFormikContext, validateYupSchema, yupToFormErrors } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsResponse,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory, useParams } from 'react-router';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APPLICATION_LISTING_STATUS,
  BankAccountTypeMaster,
  CustodianMaster,
  NDPSMBankMaster,
  NonCustodianMaster,
  SAVE_LATER_VALIDATION_CHECK,
  USER_ROLES,
  addressForTaxsMasters,
  applicantStatusMasters,
  mappingRmWithDistributors,
  srmMappedUsersMaster,
} from '../../utils/constant';
import { InfoDialog, Notes, ProceedSaveLater, SubHeading } from './components';
import UseRadioGroup from '../../lib/formik/Radio';
import { distributorsValidationSchema } from '../../utils/schema';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  applicationComparison,
  applyRoleBasedStatus,
  isNotAdvisoryFlow,
  checkIfApplicationIsNonIndividual,
  checkNDPMS,
  disableBankDetail,
  getAllStrategiesByDistributorType,
  getApplicantIdForInvestorPhotoCapture,
  getFirstErrorField,
  isBankDetailsChanged,
  isCustodianKotak,
  saveForLater,
  saveForLaterInvestorPhotoCapture,
  scrollToFieldByName,
  shouldValidateUponSaveLater,
  showPopBankDetail,
  checkAdvisoryFlow,
} from '../../utils/utilityFunctions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { ConfirmationDialog } from '../commonComponents';
import MFSelectField from '../../lib/formik/SelectField';
import { useSnackbar } from 'notistack';
import { OnEditDialogBox } from './additionalKYCDetails';
import { refLoginCheck } from '../Investments/investor-application';
import {
  ApplicantAddressType,
  ApplicationProps,
  DistributorListType,
  mappedUserMasterType,
  mappedUserUnderSrmType,
  RMType,
  StrategyDetailsType,
} from '../../redux-store/types/api-types';
import FieldValidationNote from './FieldValidationNote';
import { GetStrategiesResponseBody } from '../../redux-store/types/strategies';
import { getDistributorById, getMappedUserList } from '../../redux-store/actions/userManagement';
import { emailRegex } from '../../utils/regex';

type DistributorDetailsProps = {
  euin: string | null;
  aprn: string;
  nismNumber: string | null;
  distributorName: string | null;
  distributorPhone: string | null;
  distributorEmail: string | null;
  distributorId: number | null;
  distributorType: string | null;
  disAPRNNumber: string | null;
  disEuinNumber: string;
  loginType: string;
  firstName: string;
  // aprn?: string | null;
  empCode: string;
  phone: string | undefined;
  email: string;
  subdistributorId: number | null;
  subdistributorName: string | null;
  subAPRNNumber: string | null;
  subEuinNumber: string;
  subdistributorEmail: string | null;
  subdistributorPhone: string | null;
  filledBy: string | null;
  saveType: string;
  custodian: string;
  rm_id: number | undefined;
  mappedUserId: string;
  bankDetails: string | null;
  type?: string | null;
  srmName?: string;
  srmEmail?: string;
  srmPhone?: string;
  employeeName: string;
  employeeCode: string;
  employeeDesignation: string;
  employeeBranch: string;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({
  employeeCommonComponent,
}: {
  employeeCommonComponent?: JSX.Element;
}): JSX.Element => {
  return (
    <>
      <GridItem>
        <MFTextField
          name="firstName"
          label="RMs Name"
          placeholder="Enter RM name"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="email"
          label="RMs Email Address"
          placeholder="Enter RM Email ID"
          disabled={true}
        />
      </GridItem>
      {employeeCommonComponent}
      <GridItem>
        <MFTextField
          name="phone"
          label="RMs Mobile Number"
          placeholder="Enter RMs Mobile Number"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="aprn"
          label="RMs APRN Number"
          placeholder="Enter APRN Number"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="euin"
          label="RMs EUIN Number"
          placeholder="Enter EUIN Number"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="nismNumber"
          label="RMs NISM Certificate Number"
          placeholder="Enter NISM Certificate Number"
          disabled={true}
        />
      </GridItem>
      {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
    </>
  );
};

const DistributorDetail = ({
  handleDialogOpen,
  distributors,
  values,
  selectedDistributor,
  setSelectedDistributor,
  isDistributorIdActive = false,
  employeeCommonComponent,
}: {
  handleDialogOpen: (message: string) => void;
  distributors: Distributor[];
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: (distributor: SubDistributor[]) => void;
  isDistributorIdActive?: boolean;
  employeeCommonComponent?: JSX.Element;
}): JSX.Element => {
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);
  const [openDialog, setDialog] = useState(false);
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { application } = useSelector((store: RootStateType) => store.application);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  const handleDialogClose = () => {
    setDialog(false);
  };

  return (
    <>
      {distributors.length > 0 ? (
        <>
          {[USER_ROLES.RM].includes(role) && values.distributorId && (
            <Grid item xs={12} sx={{ textAlign: 'right' }}>
              <Button
                variant="contained"
                sx={{
                  color: 'white',
                  fontWeight: 500,
                  fontSize: 14,
                  py: 0.5,
                  px: 3,
                }}
                onClick={() =>
                  handleDialogOpen(`Are you sure you want to clear Distributor details ?`)
                }>
                Clear
              </Button>
            </Grid>
          )}
          <GridItem>
            <SearchableSelect
              name="distributorId"
              label="Distributor Code *"
              items={distributors
                .sort((distributor1, distributor2) =>
                  (distributor1['name'] || '')
                    .toString()
                    .localeCompare((distributor2['name'] || '').toString())
                )
                .map((item) => ({
                  key: (item?.name || 'NA') + ' - ' + item?.arnCode,
                  value: item?.id,
                }))}
              onChange={({ target: { value } }) => {
                const distributorCode = distributors.find((item) => item.id === value);
                const { id = null, name, aprn, type, euin } = distributorCode || {};
                setValues({
                  ...values,
                  distributorName: name,
                  disAPRNNumber: aprn,
                  disEuinNumber: euin || '',
                  distributorType: type,
                  distributorId: id,
                  type: type,
                  subdistributorId: null,
                  subdistributorName: null,
                  subAPRNNumber: null,
                  subEuinNumber: '',
                  subdistributorEmail: null,
                  subdistributorPhone: null,
                });
                setSelectedDistributor(
                  distributors.find((distributor) => distributor.id === value)?.subdistributors ||
                    []
                );
              }}
              disabled={
                [
                  USER_ROLES.DISTRIBUTOR,
                  USER_ROLES.INVESTOR,
                  USER_ROLES.POAAPPROVER,
                  USER_ROLES.SUBDISTRIBUTOR,
                ].includes(role) ||
                amcuserAsInvestor ||
                isDistributorIdActive
              }
              applyRenderValue={true}
              searchFieldPlaceholder={'Search Distributor'}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="distributorName"
              label="Distributor/IFA Name *"
              placeholder="Enter Distributor name"
              disabled={true}
            />
          </GridItem>
          {employeeCommonComponent}
          {values?.distributorId && values?.distributorType === 'individual' && (
            <>
              <GridItem>
                <MFTextField
                  name="distributorEmail"
                  label={'Distributor Email'}
                  placeholder={`Enter Distributor Email`}
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="distributorPhone"
                  label={`Distributor Mobile Number`}
                  placeholder={`Enter Distributor Mobile Number`}
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          {values.type !== 'company' && (
            <>
              <GridItem>
                <MFTextField
                  name="disEuinNumber"
                  label="Distributor EUIN Number"
                  placeholder="Enter Distributor EUIN Number"
                  disabled={true}
                />
              </GridItem>
            </>
          )}
          <GridItem>
            <MFTextField
              name="disAPRNNumber"
              label="Distributor APRN Number"
              placeholder="Enter Distributor APRN Number"
              disabled={true}
            />
          </GridItem>
          {!!selectedDistributor?.length && (
            <>
              <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label="Distributor's RM Code *"
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName + ' - ' + (item.distributors_RM_Code || 'NA'),
                      value: item.id,
                    }))}
                  onChange={({ target: { value } }) => {
                    const distributorCode = selectedDistributor.find((item) => item.id === value);
                    const { id = null, user, aprn, euin } = distributorCode || {};
                    const { email, firstName = '', phone } = user || {};
                    setValues({
                      ...values,
                      subdistributorId: id,
                      subAPRNNumber: aprn || '',
                      subEuinNumber: euin || '',
                      subdistributorEmail: email,
                      subdistributorPhone: phone,
                      subdistributorName: firstName,
                    });
                  }}
                  disabled={
                    [
                      USER_ROLES.DISTRIBUTOR,
                      USER_ROLES.INVESTOR,
                      USER_ROLES.POAAPPROVER,
                      USER_ROLES.SUBDISTRIBUTOR,
                    ].includes(role) || amcuserAsInvestor
                  }
                  searchFieldPlaceholder={"Search Distributor's RM"}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorName"
                  label="Distributor's RM Name *"
                  placeholder="Enter Distributor name"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorEmail"
                  label="Distributor's RM Email *"
                  placeholder="Enter Distributor email"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorPhone"
                  label="Distributor's RM Phone Number"
                  placeholder="Enter Distributor Phone Number"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subAPRNNumber"
                  label="Distributor's RM APRN Number"
                  placeholder="Enter Distributor APRN Number"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subEuinNumber"
                  label="Distributor's RM EUIN Number"
                  placeholder="Enter Distributor EUIN Number"
                  disabled={true}
                />
              </GridItem>
              {/* <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label="Distributor RM/Advisor Name-Location *"
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName + ' - ' + (item.distributors_RM_Code || 'NA'),
                      value: item.id,
                    }))}
                  onChange={({ target: { value } }) => {
                    const distributorCode = selectedDistributor.find((item) => item.id === value);
                    const { id = null, user, aprn, euin } = distributorCode || {};
                    const { email, firstName = '' } = user || {};
                    setValues({
                      ...values,
                      subdistributorId: id,
                      subdistributorEmail: email,
                      subAPRNNumber: aprn,
                      subEuinNumber: euin,
                      subdistributorName: firstName,
                    });
                  }}
                  disabled={
                    [
                      USER_ROLES.DISTRIBUTOR,
                      USER_ROLES.INVESTOR,
                      USER_ROLES.POAAPPROVER,
                      USER_ROLES.SUBDISTRIBUTOR,
                    ].includes(role) || amcuserAsInvestor
                  }
                  searchFieldPlaceholder={"Search Distributor's RM"}
                />
              </GridItem> */}
            </>
          )}
          {!application?.srm_id && (
            <GridItem>
              <MFTextField name="filledBy" label="Filled by" placeholder="Enter filled by" />
              <Typography
                component="span"
                sx={{ position: 'relative', left: 64, bottom: { xs: 85, md: 91 } }}>
                <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
              </Typography>
            </GridItem>
          )}
          <InfoDialog
            onClose={handleClose}
            open={open}
            content={'Please add the Name of the Subdistributor RM.'}
          />
        </>
      ) : (
        <Grid
          xs={12}
          sm={12}
          sx={{
            fontSize: 18,
            fontWeight: 500,
            color: '#2057A6',
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            justifyContent: 'center',
            mt: { lg: 9, xs: 9 },
            mb: 2.9,
            ml: { xs: 3 },
          }}>
          No distributor mapped under this RM
        </Grid>
      )}
    </>
  );
};
const SRMDetail = ({
  savedDistributors,
  handleDialogOpen,
  values,
  selectedDistributor,
  setSelectedDistributor,
  mappedusersDetailsList,
  employeeCommonComponent,
}: {
  savedDistributors: Distributor[];
  handleDialogOpen: (message: string) => void;
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: any;
  mappedusersDetailsList: mappedUserUnderSrmType;
  employeeCommonComponent: JSX.Element;
}) => {
  const [srmsLoading, setSrmsLoading] = useState(false);
  const [distributor, setDistributor] = useState<Distributor[]>([]);
  const dispatch = useDispatch();
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const { setValues } = useFormikContext();
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const { application } = useSelector((store: RootStateType) => store.application);

  const mappedusersList = mappedusersDetailsList?.mappedUsers?.map((users, index) => {
    let role = '';
    if (users?.type === 'company') {
      role = 'distributor';
    } else if (users?.user?.role) {
      role = users?.user?.role;
    }
    return {
      name: users?.name,
      id: users?.id || null,
      type: users?.type || '',
      role: role,
    };
  });

  const addUserDetails = async (mappedUserDetail: string) => {
    const idAndRole = mappedUserDetail?.split('-');
    const userRole = idAndRole[1];
    const userId = parseInt(idAndRole[0], 10);
    if (srmMappedUsersMaster[userRole] === srmMappedUsersMaster?.rm) {
      const selectedRM = (mappedusersDetailsList?.mappedUsers as RMType[])?.find(
        (user) => user?.id === userId && user?.user?.role === userRole
      );
      setValues({
        ...values,
        mappedUserId: mappedUserDetail || '',
        rm_id: selectedRM?.id || null,
        phone: selectedRM?.user?.phone || '',
        firstName: selectedRM?.user?.firstName || '',
        email: selectedRM?.user?.email || '',
        nismNumber: selectedRM?.nismNumber || '',
        distributorNismNumber: null,
        subDistributorNismNumber: null,
        distributorId: null,
        distributorName: '',
        distributorPhone: '',
        distributorEmail: '',
        distributorType: '',
        subdistributorId: null,
        subdistributorName: null,
        subdistributorEmail: null,
        subdistributorPhone: null,
      });
      setSelectedDistributor([]);
    } else if (srmMappedUsersMaster[userRole] === srmMappedUsersMaster?.distributor) {
      try {
        const mappedDistributor = (
          mappedusersDetailsList?.mappedUsers as DistributorListType[]
        )?.find((user) => {
          return (
            user?.id === userId &&
            (user?.user?.role === 'rm' || user?.user?.role === 'distributor' || user?.type)
          );
        });
        if (mappedDistributor?.type === 'company') {
          setSrmsLoading(true);
          const res = (await dispatch(
            getDistributorById(mappedDistributor?.id as number)
          )) as unknown as Distributor;

          setDistributor([res]);
          setSelectedDistributor(res?.subdistributors || []);
        } else {
          setDistributor([mappedDistributor || {}] as Distributor[]);
          setSelectedDistributor([]);
        }
        setValues({
          ...values,
          mappedUserId: mappedUserDetail || '',
          rm_id: null,
          phone: '',
          firstName: '',
          email: '',
          nismNumber: '',
          distributorId: mappedDistributor?.id,
          distributorName: mappedDistributor?.name,
          distributorPhone: mappedDistributor?.user?.phone,
          distributorEmail: mappedDistributor?.user?.email,
          distributorType: mappedDistributor?.type,
          subdistributorId: null,
          subdistributorName: null,
          subdistributorEmail: null,
          subdistributorPhone: null,
          subDistributorNismNumber: null,
        });
        setSrmsLoading(false);
      } catch (e: unknown) {
        setSrmsLoading(false);
        console.error((e as Error).message);
      }
    }
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  return (
    <>
      <Grid item xs={12}>
        <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
          SRM Details
        </SubHeading>
      </Grid>
      <GridItem>
        <MFTextField
          name="srmName"
          label="SRM's Name"
          placeholder="Enter RM name"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="srmEmail"
          label="SRM's Email Address"
          placeholder="Enter SRM's Email Address"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="srmPhone"
          label="SRM's Mobile Number"
          placeholder="Enter SRM's Mobile Number"
          disabled={true}
        />
      </GridItem>
      <GridItem>
        <SearchableSelect
          name="mappedUserId"
          label="Mapped Users *"
          items={(mappedusersList || [])?.map((item: mappedUserMasterType) => ({
            key: `${item?.name} (${item?.type ? item?.type + ' ' : ''}${
              srmMappedUsersMaster[item?.role || '']
            })`,
            value: `${item?.id}-${item?.role !== 'rm' ? 'distributor' : 'rm'}` as string,
          }))}
          onChange={({ target: { value } }) => {
            addUserDetails((value || '') as string);
          }}
          disabled={
            [
              USER_ROLES.DISTRIBUTOR,
              USER_ROLES.INVESTOR,
              USER_ROLES.POAAPPROVER,
              USER_ROLES.AMC_ADMIN,
              USER_ROLES.SUBDISTRIBUTOR,
            ].includes(role) ||
            amcuserAsInvestor ||
            srmsLoading
          }
          applyRenderValue={false}
          searchFieldPlaceholder="Search Mapped Users"
        />
        {srmsLoading && (
          <Box sx={{ display: 'flex' }}>
            <CircularProgress size={30} />
          </Box>
        )}
      </GridItem>
      {employeeCommonComponent}
      {values?.rm_id && (
        <>
          <Grid item xs={12}>
            <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
              RM Details
            </SubHeading>
          </Grid>
          <RMDetail />
        </>
      )}
      {values?.distributorId && (
        <>
          <Grid item xs={12}>
            <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
              Distributor Details
            </SubHeading>
          </Grid>

          <DistributorDetail
            handleDialogOpen={handleDialogOpen}
            distributors={
              distributor?.length > 0
                ? distributor
                : ((application?.distributor
                    ? Array.isArray(application.distributor)
                      ? application.distributor
                      : [application.distributor]
                    : []
                  ).filter(Boolean) as Distributor[])
            }
            values={values}
            selectedDistributor={selectedDistributor}
            setSelectedDistributor={setSelectedDistributor}
            isDistributorIdActive={true}
          />
        </>
      )}
    </>
  );
};
export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role, id: authId = '' } = useSelector((store: RootStateType) => store.auth);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const referenceDetail = useSelector((store: RootStateType) => store.refrenceIdReducer);
  const [showDialogForEdit, setShowShowForEdit] = useState(false);
  const [finalvalue, setFinalValue] = useState<any>();
  const [dialogMessage, setDialogMessage] = useState('');
  const [loginTypeRole, setLoginTypeRole] = useState('');
  const [openDialog, setDialog] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [mappedusersDetailsList, setMappedusersDetailsList] = useState<mappedUserUnderSrmType>();
  const employeeCommonComponent = (
    <>
      {application && checkIfApplicationIsNonIndividual(application as ApplicationProps) ? (
        <>
          <GridItem>
            <MFTextField
              name="employeeName"
              label="Employee Name *"
              placeholder="Enter Employee name"
              disabled={false}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="employeeCode"
              label="Employee Code *"
              placeholder="Enter Employee code"
              disabled={false}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="employeeDesignation"
              label="Employee Designation *"
              placeholder="Enter Employee designation"
              disabled={false}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="employeeBranch"
              label="Employee Branch *"
              placeholder="Enter Employee branch"
              disabled={false}
            />
          </GridItem>
        </>
      ) : (
        <></>
      )}
    </>
  );
  const {
    distributor,
    rm,
    srm,
    subdistributorId = null,
    subDistributor,
    filledBy = '',
    custodian = '',
    bankDetails = '',
    accountType,
    bankAccountTypeNdpms = '',
    employeeName,
    employeeDesignation,
    employeeBranch,
    employeeCode,
  } = application || {};

  const {
    name,
    id,
    type,
    aprn: disAPRNNumber,
    euin: disEuinNumber = '',
  } = distributor || {
    arnCode: '',
    name: '',
    id: null,
  };
  const {
    user: { email: distributorEmail, phone: distributorPhone = '' },
  } = distributor || { user: { phone: '', email: '' } };
  const {
    empCode,
    euin,
    aprn,
    nismNumber,
    user: { id: rmId, email: RMEmail = '', firstName: RMFirstName = '', phone },
  } = rm || { empCode: '', euin: '', nismNumber: '', aprn: '', user: { email: '' } };

  const {
    name: srmName,
    user: { email: srmEmail = '', phone: srmPhone },
  } = srm || { user: { email: '', phone: undefined } };
  const {
    aprn: subAPRNNumber,
    euin: subEuinNumber = '',
    user: {
      firstName: subdistributorName,
      email: subdistributorEmail,
      phone: subdistributorPhone = '',
    },
  } = subDistributor || { user: { firstName: '', email: '', phone: '' } };
  const mappedUserId = id
    ? `${id}-distributor`
    : application?.rm_id
    ? `${application?.rm_id}-rm`
    : '';
  const initialValues: DistributorDetailsProps = {
    distributorId: id,
    distributorName: name,
    disAPRNNumber: disAPRNNumber ?? null,
    disEuinNumber: disEuinNumber,
    euin: euin,
    aprn: aprn,
    nismNumber: nismNumber,
    distributorPhone: distributorPhone,
    distributorEmail: distributorEmail,
    distributorType: type ?? null,
    loginType: application?.srm_id ? role : 'rm',
    rm_id: application?.rm_id,
    empCode,
    email: RMEmail,
    phone: phone,
    firstName: RMFirstName,
    subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
    subdistributorName,
    subAPRNNumber: subAPRNNumber ?? null,
    subEuinNumber: subEuinNumber,
    subdistributorEmail,
    subdistributorPhone,
    filledBy,
    saveType: 'save and proceed',
    custodian,
    mappedUserId: mappedUserId,
    bankDetails,
    srmName,
    srmEmail,
    srmPhone,
    employeeName: employeeName || '',
    employeeDesignation: employeeDesignation || '',
    employeeBranch: employeeBranch || '',
    employeeCode: employeeCode || '',
  };
  const handleDialogOpen = (message: string) => {
    setDialogMessage(message);
    setDialog(true);
  };
  const handleDialogClose = () => {
    setDialog(false);
    setDialogMessage('');
    setLoginTypeRole('');
  };
  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoginTypeRole(role || '');
        if (Object.keys(application || {}).length && role === USER_ROLES.RM) {
          const res = (await dispatch(
            getDistributors({ isActive: true })
          )) as unknown as getDistributorsResponse;
          const { distributors = [] } = res || {};
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: [application.subDistributor],
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor =
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find((distributor) => distributor.id === id)
                      ?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => distributor.id === id)
                    ?.subdistributors || [];
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);

            // console.log(loginType, 'selected distri');
          }
        } else if (Object.keys(application || {}).length && role === USER_ROLES.SRM) {
          setLoginTypeRole(role || '');
          const res = (await dispatch(
            getMappedUserList({ isActive: true })
          )) as unknown as mappedUserUnderSrmType;
          setMappedusersDetailsList(res);
          const selectedDistributor = (res?.mappedUsers as DistributorListType[])
            ?.map((user) => {
              return { ...user };
            })
            ?.find((item) => {
              return item?.id === application?.distributor_id;
            });

          if (application?.distributor_id) {
            const updatedDistributor =
              application?.distributor_id && !application.distributor.isActive
                ? [
                    ...[selectedDistributor],
                    {
                      ...application.distributor,
                      subdistributors: [application.subDistributor],
                    } as Distributor,
                  ]
                : [selectedDistributor];

            if (isComponentActive) {
              setSelectedDistributor(
                (application?.subDistributor?.id
                  ? [application?.subDistributor || {}]
                  : []) as unknown as SubDistributor[]
              );
              setDistributors(updatedDistributor as unknown as Distributor[]);
            }
          }
        } else {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as SubDistributor]
              : []
          );
        }
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application]);

  const { referenceId: referenceIdForInvestorPhotoCapture } = useParams<{ referenceId: string }>();
  const handleapplicationComparison = (
    values: DistributorDetailsProps,
    application: ApplicationProps | null,
    applicationStrategydetails = {},
    strategiesFeeType = application?.strategiesFeeType || '',
    applicants = application?.applicants,
    isSaveLater: boolean
  ): boolean => {
    const {
      distributorId,
      subdistributorId,
      filledBy,
      custodian,
      bankDetails,
      rm_id,
      saveType,
      employeeName,
      employeeDesignation,
      employeeBranch,
      employeeCode,
    } = values;
    return applicationComparison(application, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...application!,
      rm_id,
      distributor_id: distributorId,
      subdistributorId: subdistributorId ? subdistributorId.toString() : subdistributorId,
      filledBy: filledBy,
      custodian,
      bankDetails: checkNDPMS(accountType) ? bankDetails : '',
      currentStep: SAVE_LATER_VALIDATION_CHECK
        ? application?.currentStep === null
          ? 1
          : application?.currentStep
        : isSaveLater
        ? 0
        : application?.currentStep || 1,
      ...applicationStrategydetails,
      applicants,
      strategiesFeeType,
      employeeName,
      employeeDesignation,
      employeeBranch,
      employeeCode,
    });
  };
  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const {
        distributorId,
        subdistributorId,
        filledBy,
        custodian,
        bankDetails,
        mappedUserId,
        srmEmail,
        srmName,
        srmPhone,
        saveType,
        employeeName,
        employeeDesignation,
        employeeBranch,
        employeeCode,
      } = values;
      const {
        id,
        applicant1ReferenceId,
        currentStep = null,
        banks,
        status,
        hasPOA,
        applicationNumber,
      } = application || {};
      const isSaveLater = saveType !== 'save and proceed';
      let applicationStrategydetails = {};
      let response = [] as GetStrategiesResponseBody[];
      let strategiesFeeType = application?.strategiesFeeType || '';
      let applicants = application?.applicants;
      const isDistributorPresent =
        !distributorId &&
        application?.distributor_id &&
        (application?.applicationstrategydetails || [])?.length > 0;
      if (distributorId || isDistributorPresent) {
        try {
          if (
            (distributorId && Number(distributorId) !== Number(application?.distributor_id)) ||
            isDistributorPresent
          ) {
            setButtonDisable(true);
            response = (await getAllStrategiesByDistributorType(dispatch, {
              ...application,
              distributor_id: distributorId,
            } as ApplicationProps)) as unknown as GetStrategiesResponseBody[];
          }

          setButtonDisable(false);
          const responseId = response?.map((responseIdData) => responseIdData.id?.toString());

          if ((application?.applicationstrategydetails || [])?.length > 0 && response?.length > 0) {
            applicationStrategydetails = {
              applicationstrategydetails: (application?.applicationstrategydetails?.map(
                (_application_stratagy) => {
                  const feeDetailsCheck = response
                    .find(
                      (_stratagy_id) =>
                        Number(_stratagy_id.id) === Number(_application_stratagy?.strategyId)
                    )
                    ?.strategyFeeDetails?.map((_feeDetails) => _feeDetails.id)
                    .includes(_application_stratagy?.strategyFeeDetailId || '');
                  if (!responseId.includes(_application_stratagy?.strategyId?.toString())) {
                    strategiesFeeType = '';
                    return {
                      ..._application_stratagy,
                      isActive: false,
                    };
                  }
                  if (!feeDetailsCheck) {
                    strategiesFeeType = '';
                    return {
                      ..._application_stratagy,
                      isActive: false,
                    };
                  }
                  return _application_stratagy;
                }
              ) || []) as StrategyDetailsType[],
            };
          }
        } catch (e) {
          setButtonDisable(false);
          console.error((e as Error).message);
        }
      }
      if (isCustodianKotak(values?.custodian || '')) {
        applicants = application?.applicants.map((_applicant) => {
          if (
            _applicant?.fatcaAddress &&
            addressForTaxsMasters[_applicant?.fatcaAddress?.address_type || ''] !==
              addressForTaxsMasters.others
          ) {
            return {
              ..._applicant,
              fatcaAddress: {
                ...(_applicant?.fatcaAddress as ApplicantAddressType),
                isActive: false,
              },
            };
          } else {
            return _applicant;
          }
        });
      }

      const checkApplication = handleapplicationComparison(
        values,
        application,
        applicationStrategydetails,
        strategiesFeeType,
        applicants,
        isSaveLater
      );

      //save for later route for investor at liveliness
      const investorEditSaveelaterRoute =
        referenceIdForInvestorPhotoCapture &&
        saveForLaterInvestorPhotoCapture(referenceIdForInvestorPhotoCapture, application);
      const referenceIdForSaveProceedRoute = referenceIdForInvestorPhotoCapture
        ? referenceIdForInvestorPhotoCapture
        : referenceDetail.esignReferenceId;

      if (id && !checkApplication) {
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...application!,
              ...applicationStrategydetails,
              rm_id: values?.rm_id,
              applicants,
              strategiesFeeType,
              distributor_id: distributorId,
              subdistributorId,
              employeeName,
              employeeDesignation,
              employeeBranch,
              employeeCode,
              status:
                !hasPOA &&
                AMC_APPROVER_CHECK_FOR_INDIVIDUAL &&
                status !== 'draft' &&
                applyRoleBasedStatus(role)
                  ? 'sent_to_amc_approver'
                  : status,
              banks: isBankDetailsChanged(application?.bankDetails, values.bankDetails)
                ? application?.banks.length
                  ? application?.banks.map((applicant) => {
                      return { ...applicant, isActive: false };
                    })
                  : application?.banks
                : application?.banks,
              currentStep: SAVE_LATER_VALIDATION_CHECK ? 1 : isSaveLater ? 0 : 1,
              ...((!SAVE_LATER_VALIDATION_CHECK as boolean) && { saveForLater: isSaveLater }),
              //currentStep === null ? 1 : currentStep
              filledBy,
              custodian,
              bankDetails: checkNDPMS(accountType) ? bankDetails : '',
              ndpmsSectionEdited: showDialogForEdit ? true : application?.ndpmsSectionEdited,
            },
            applicationId: id,
            ...(saveType !== 'save and proceed' && {
              toastMessage: '',
            }),
          })
        );
        !isSaveLater
          ? history.push('contributor-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      } else if (checkApplication) {
        if (isSaveLater) {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        !isSaveLater
          ? history.push('contributor-details', {
              id,
              applicant1ReferenceId: referenceIdForSaveProceedRoute,
            })
          : referenceIdForInvestorPhotoCapture
          ? history.push(
              investorEditSaveelaterRoute.routePath,
              investorEditSaveelaterRoute.routeState
            )
          : history.push(saveForLater(role, id, referenceDetail.esignReferenceId));
      }
    } catch (e) {
      setLoading(false);
      console.error((e as Error).message);
    }
  };

  const manageSubmit = (values: DistributorDetailsProps) => {
    const { bankAccountFormCreated = false, showBankIcon = false } = application || {};
    const { bankDetails = '' } = values;
    const checkApplication = applicationComparison(application, {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...application,
      bankDetails: checkNDPMS(accountType) ? bankDetails : '',
    });
    if (
      showPopBankDetail(
        checkApplication,
        accountType,
        bankAccountFormCreated,
        showBankIcon,
        bankDetails,
        role
      )
    ) {
      setFinalValue(values);
      setShowShowForEdit(true);
    } else {
      onSubmit(values);
    }
  };

  const amcuserAsInvestor = refLoginCheck(
    authId,
    application as unknown as ApplicationProps,
    referenceDetail
  );

  const isFieldDisabled = [USER_ROLES.INVESTOR].includes(role) || amcuserAsInvestor;

  return (
    <Formik
      initialValues={initialValues}
      validate={(values: DistributorDetailsProps) => {
        try {
          validateYupSchema(
            values,
            distributorsValidationSchema(
              selectedDistributor,
              USER_ROLES.SRM === role
                ? ((mappedusersDetailsList?.mappedUsers || []) as any)
                : distributors,
              checkNDPMS(accountType),
              shouldValidateUponSaveLater(values.saveType),
              role,
              checkAdvisoryFlow(application?.accountType || ''),
              checkIfApplicationIsNonIndividual(application as ApplicationProps)
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={manageSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues, resetForm, errors }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Notes
            displayContent={
              'This section specifies whether the application is from an RM/Distributor’s RM.'
            }
          />
          <Grid container rowSpacing={2} columnSpacing={5} sx={{ pt: '25px !important' }}>
            {[USER_ROLES.RM, USER_ROLES.INVESTOR].includes(role) && mappingRmWithDistributors && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={[
                    { label: 'RM', value: USER_ROLES.RM },
                    { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                  ]}
                />
              </Grid>
            )}
            {application?.srm_id &&
            ![
              USER_ROLES.DISTRIBUTOR,
              USER_ROLES.SUBDISTRIBUTOR,
              USER_ROLES.POAAPPROVER,
              USER_ROLES.RM,
            ].includes(role) ? (
              <SRMDetail
                savedDistributors={distributors || []}
                handleDialogOpen={handleDialogOpen}
                values={values}
                selectedDistributor={selectedDistributor}
                setSelectedDistributor={setSelectedDistributor}
                mappedusersDetailsList={mappedusersDetailsList as mappedUserUnderSrmType}
                employeeCommonComponent={employeeCommonComponent}
              />
            ) : (
              <>
                {(application?.rm_id || mappingRmWithDistributors) &&
                ![
                  USER_ROLES.DISTRIBUTOR,
                  USER_ROLES.SUBDISTRIBUTOR,
                  USER_ROLES.POAAPPROVER,
                ].includes(role) &&
                values.loginType === USER_ROLES.RM ? (
                  <RMDetail employeeCommonComponent={employeeCommonComponent} />
                ) : (
                  <>
                    {(application?.distributor_id || mappingRmWithDistributors) && (
                      <DistributorDetail
                        handleDialogOpen={handleDialogOpen}
                        distributors={distributors}
                        values={values}
                        selectedDistributor={selectedDistributor}
                        setSelectedDistributor={(subdistributors) =>
                          setSelectedDistributor(subdistributors)
                        }
                        employeeCommonComponent={employeeCommonComponent}
                      />
                    )}
                  </>
                )}
              </>
            )}
            {isNotAdvisoryFlow(application?.accountType || '') && (
              <>
                <Grid item xs={12}>
                  <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
                    {'Custodian Details'}
                  </SubHeading>
                </Grid>

                <GridItem>
                  <MFSelectField
                    name={`custodian`}
                    label={'Custodian Name *'}
                    items={
                      application &&
                      checkIfApplicationIsNonIndividual(application as ApplicationProps)
                        ? Object.keys(NonCustodianMaster).map((item) => ({
                            key: NonCustodianMaster[item],
                            value: item,
                          }))
                        : Object.keys(CustodianMaster).map((item) => ({
                            key: CustodianMaster[item],
                            value: item,
                          }))
                    }
                    applyLabelStyles={true}
                    disabled={
                      (values.loginType === USER_ROLES.DISTRIBUTOR && distributors.length === 0) ||
                      isFieldDisabled ||
                      [USER_ROLES.AMCAPPROVER].includes(role)
                    }
                  />
                </GridItem>

                {checkNDPMS(accountType) && (
                  <>
                    <Grid item xs={12}>
                      <SubHeading sx={{ color: 'common.primary', letterSpacing: 0.5 + 'px' }}>
                        {'Bank Details'}
                      </SubHeading>
                    </Grid>
                    <GridItem>
                      <MFSelectField
                        name={`bankDetails`}
                        label={'Bank Details *'}
                        items={Object.keys(NDPSMBankMaster).map((item) => ({
                          key: NDPSMBankMaster[item],
                          value: item,
                        }))}
                        applyLabelStyles={true}
                        disabled={
                          (values.loginType === USER_ROLES.DISTRIBUTOR &&
                            distributors.length === 0) ||
                          isFieldDisabled ||
                          disableBankDetail(
                            role,
                            application?.status,
                            application?.bankAccountFormCreated,
                            application?.showBankIcon
                          )
                        }
                      />
                    </GridItem>
                  </>
                )}
              </>
            )}
          </Grid>
          <OnEditDialogBox
            open={showDialogForEdit}
            setOpen={setShowShowForEdit}
            handleSubmit={onSubmit}
            values={finalvalue}
            message={'Please confirm if new bank account is not to be opened for this application'}
          />
          <FieldValidationNote />
          <ProceedSaveLater
            saveLater={() => {
              setTimeout(() => {
                const firstErrorField = getFirstErrorField(errors);
                scrollToFieldByName(firstErrorField || '');
              }, 0);
              setValues({
                ...values,
                saveType: 'save for later',
              });
            }}
            saveAndProceed={() => {
              setTimeout(() => {
                const firstErrorField = getFirstErrorField(errors);
                scrollToFieldByName(firstErrorField || '');
              }, 0);
              setValues({
                ...values,
                saveType: 'save and proceed',
              });
            }}
            disabled={buttonDisable}
            loader={loading}
            clickedButton={values.saveType}
          />
          <ConfirmationDialog
            message={dialogMessage}
            open={openDialog}
            setOpen={handleDialogClose}
            onSave={() => {
              handleDialogClose();
              resetForm();
              setValues({
                ...values,
                loginType: loginTypeRole || values.loginType,
                distributorName: '',
                distributorPhone: '',
                distributorEmail: '',
                distributorId: null,
                subdistributorId: null,
                subdistributorName: '',

                subdistributorEmail: '',
              });
              setSelectedDistributor([]);
            }}
            onCancel={handleDialogClose}
          />
        </Box>
      )}
    </Formik>
  );
}
